import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoringVerificationComponent } from './scoring-verification.component';



@NgModule({
  declarations: [ScoringVerificationComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ScoringVerificationComponent
  ]
})
export class ScoringVerificationModule { }
